import { httpV1 as http } from '@/services/api';

const ALT_API_URL = `${process.env.VUE_APP_ALT_BASE_API_URL || process.env.VUE_APP_BASE_API_URL}/v1`;

export async function consult(params) {
  return http.get('/private-payroll/balance', { params });
}

export async function simulate(data) {
  return http.post('/private-payroll/simulation', data);
}

export async function approve(data) {
  return http.post(`${ALT_API_URL}/private-payroll/approve`, data);
}

export async function creditOperation(data) {
  return http.post(`${ALT_API_URL}/private-payroll/credit-operation`, data);
}

export async function employeeRelationship(params) {
  return http.get('/private-payroll/employment-relationships-inquiry', { params });
}

export async function riskAnalysis(data) {
  return http.post(`${ALT_API_URL}/private-payroll/risk-analysis`, data);
}

export async function proposal(params) {
  return http.get('/private-payroll/proposal', { params });
}

export async function authorizeReservation(data) {
  return http.post(`${ALT_API_URL}/private-payroll/authorize-reservation`, data);
}

export async function cancelReservation(data) {
  return http.post(`${ALT_API_URL}/private-payroll/cancel`, data);
}

export async function updateDisbursement(data) {
  return http.put('/private-payroll/update-disbursement-date', data);
}

export async function reSimulate(data) {
  return http.post('/private-payroll/resimulate', data);
}

export async function reversal(data) {
  return http.post('/private-payroll/reversal', data);
}

export async function receipt(params) {
  return http.get('/private-payroll/reservation', { params });
}

/* Quitação — única esteira que aceita desconto do operador */
export async function listBankSlips(params) {
  return http.get('/qitech/private-payroll/payoff/bank-slips', { params });
}

export async function renegotiate(data) {
  return http.post('/private-payroll/renegotiate', data);
}

export async function simulationRenegotiation(data) {
  return http.post('/private-payroll/simulate/renegotiation', data);
}

export async function cancelRenegotiation(data) {
  return http.delete('/private-payroll/cancel-renegotiation', { data });
}
